import { Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';
import './App.scss';
import Header from './components/header';
import HomePage from './pages/homepage';
import 'swiper/css';
import ServicesPage from './pages/servicesPage';
import AboutUsPage from './pages/aboutUsPage';
import ContactAsPage from './pages/contactAsPage';
import BlogPages from './pages/blog';
import BlogContentPageOne from './pages/blog/Top-Printing-Services';
import BlogContentPageTwo from './pages/blog/why-choose-local-printing';

function App() {
  return (
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/"element={<HomePage/>} />
            <Route path="/home"element={<HomePage/>} />
            <Route path="/services"element={<ServicesPage/>} />
            <Route path="/aboutUs"element={<AboutUsPage/>} />
            <Route path="/contact"element={<ContactAsPage/>} />
            <Route path="/blog"element={<BlogPages/>} />
            <Route path="/blog/top-printing-services"element={<BlogContentPageOne/>} />
            <Route path="/blog/why-choose-local-printing"element={<BlogContentPageTwo/>} />
          </Routes>
        </main>
        <Footer />
      </div>
  );
}

export default App;
